var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"biew-badge px-4 py-2 bg-gray-900 text-white font-light",attrs:{"href":"https://getbiew.com/"}},[_vm._v(" "+_vm._s(_vm.lang === "es" ? "Hecho con" : "Made with")+" "),_c('span',{staticClass:"font-bold"},[_vm._v("Biew")])])}
var staticRenderFns = []

export { render, staticRenderFns }